export const isRouteGet = (path) => {
  return cachedRoute.some((route) => path.includes(route));
};

const cachedRoute = [
  '/repository/tourOperator',
  '/repository/travelCategory',
  '/repository/leisureCategory',
  '/repository/countryList',
  '/repository/countryList/tourOperator/',
  '/repository/departureCityList',
  '/repository/leisureCityList',
  '/repository/packageList',
  '/repository/business',
  '/repository/sportWellnessCategory'
];
